import React from 'react';
import { Link } from 'react-router-dom';


function ProgramTags(props) {
  const { tags } = props.programData;

  if (!tags || !tags.length) {
    return null;
  }

  return (
    <div className="tags-container">
      {tags.map((tag, index) => (
        <Link
          key={tag.id}
          title={tag.name}
          to={`/archives/tag/${tag.slug}`}
        >
          #{tag.name + ((tags.length - 1 === index) ? '' : ', ')}
        </Link>
      ))}
    </div>
  );
}

export default ProgramTags;
